import axios from 'axios';

const instance = axios.create({});

instance.interceptors.request.use(config => {
  const recaptchaToken = sessionStorage.getItem('recaptchaToken');

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return config;
});

export default instance;
